import { useContext, useState, useEffect, useRef } from 'react';
import { Modal } from 'react-bootstrap';
import PageContext from './PageContext';
import { HttpContext } from '../../api-services/HttpService';
import { useSelector, useDispatch } from "react-redux";
import ApiRequestButton from './ApiRequestButton';
import AutoComplete from './AutoCompleteInputWithOptionsCopy.jsx'; 
import BannerAlert from './BannerAlert'; 
import CCOffcanvas from './CCOffcanvas.tsx';
import ButtonComponent from './ButtonComponent.jsx';

const AddConsortiumMasterCompany = () => {
    // get page context from parent
    const {
        addConsortiumMasterCompanyModal, 
        setAddConsortiumMasterCompanyModal, 
        portfolio, 
        masterCompanyList, 
        snackbarAlert, 
        getConsortiumData, 
    } = useContext(PageContext); 
    // get HTTP context from parent
    const {
        POST, 
    } = useContext(HttpContext); 
    // get global redux state 
    const consortiumId = useSelector((state) => state.consortiumId);
    // initialize state 
    const [masterCompanyId, setMasterCompanyId] = useState(''); 
    const [masterCompanyObj, setMasterCompanyObj] = useState({label: '', id: ''}); 

    // event handler for submit button click 
    const onSubmitClick = () => {
        return new Promise((resolve, reject) => {
            console.log(masterCompanyObj); 
            console.log(!masterCompanyList.includes(masterCompanyObj)); 
            // validate the mastercompanyobj 
            if (!masterCompanyList.includes(masterCompanyObj)) {
                snackbarAlert(true, 'Invalid ' + process.env.REACT_APP_MASTER_COMPANY_ID_TAG + '.', 'error'); 
                reject(); 
                return; 
            }
            // use PUT function to make request
            POST('/consortium/addConsortiumMasterCompany', {
                consortiumid: consortiumId, 
                mastercompanyid: masterCompanyObj['id'], 
            }).then(res => {
                console.log(res); 
                // return value to default 
                setMasterCompanyId(masterCompanyId => masterCompanyId = ''); 
                setMasterCompanyObj(masterCompanyObj => masterCompanyObj = {label: '', id: ''}); 
                // show snackbar on error
                snackbarAlert(true, 'Successfully added ' + process.env.REACT_APP_MASTER_COMPANY_ID_TAG + '.', 'success');
                // hide modal 
                setAddConsortiumMasterCompanyModal(addConsortiumMasterCompanyModal => addConsortiumMasterCompanyModal = false); 
                // refresh data
                return getConsortiumData();  
            }).then(res => {
                console.log(res); 
                // resolve on success 
                resolve(res); 
            }).catch(err => {
                // show snackbar on error
                snackbarAlert(true, 'Error adding ' + process.env.REACT_APP_MASTER_COMPANY_ID_TAG + '.', 'error');
                // reject on error
                reject(err); 
            }); 
        }); 
        
    }

    return(
        <> 
        <CCOffcanvas
                title={`Add ${process.env.REACT_APP_MASTER_COMPANY_ID_TAG} to ${consortiumId}`}
                show={addConsortiumMasterCompanyModal}
                onCanvasClose={()=>setAddConsortiumMasterCompanyModal(addConsortiumMasterCompanyModal => addConsortiumMasterCompanyModal = false)}
                bodyCssClassName="offcanvas-body bg-white p-3"
                offCanvasClassName="offcanvas-parent-card-40"
            >
                <div className="d-flex flex-column h-100">
                    <div className="d-flex flex-column gap-3 flex-grow-1 overflow-scroll">
                        <div>
                            <AutoComplete tag={process.env.REACT_APP_MASTER_COMPANY_ID_TAG} value={masterCompanyId} setValue={setMasterCompanyId} obj={masterCompanyObj} setObj={setMasterCompanyObj} list={masterCompanyList} width='100%' topAlignTypography={true}/>
                            <div className='mt-3'>
                                <BannerAlert show={true} type='warning' message={'Warning: ' + process.env.REACT_APP_MASTER_COMPANY_ID_TAG + ' portfolio will be changed to ' + portfolio + '.' } width='100%' />
                            </div>
                        </div>

                    </div>
                    <div
                        className="d-flex justify-content-end p-3 w-100 offcanvas-footer z-2" style={{height: '65px'}}
                    >
                        <ButtonComponent tag={"Cancel"}
                            border={'#fcd800 1px solid'} background={'#fff'} color={'#001317'}
                            onButtonClick={() => setAddConsortiumMasterCompanyModal(addConsortiumMasterCompanyModal => addConsortiumMasterCompanyModal = false)}
                        />
                        {/* button to submit company entitlement edit */}
                        <ApiRequestButton onButtonClick={onSubmitClick} />
                    </div>
                </div>
            </CCOffcanvas>
        </>
    );
}

export default AddConsortiumMasterCompany; 